import React from 'react';
import cn from 'classnames';

import styles from './EmptyResultOverlay.module.scss';

interface IProps {
  content: string,
  className?: string,
}

const EmptyResultOverlay = ({ content, className }: IProps) => (
  <div className={ cn(styles.emptyResultOverlay, className) }>
    <p>{ content }</p>
  </div>
);

export default EmptyResultOverlay;
